export default "__VITE_ASSET__61777049__"